import React from 'react';

import { SEO } from 'main/components';
import {
  Cards,
  ConnectionBoost,
  Hero,
  Specifications,
  Visualizations,
} from 'modules/powerMeterV2';

export const PowerMeterV2 = () => {
  return (
    <>
      <SEO
        seoTitle="Powermeter - RF Power Meter v2 - Orqa"
        seoDescription="Test your FPV video and control links with the RF Power Meter v2. Essential for ensuring race compliance, diagnosing signal issues, and optimizing antenna performance."
      />
      <section className="power-meter-section">
        <Hero />
        <Cards />
        <Visualizations />
        <Specifications />
        <ConnectionBoost />
      </section>
    </>
  );
};
